<template>
  <v-flex
    v-if="getWhiteLabel && getWhiteLabel.aff_plan"
    xs12
    md4
    pa-2
  >
    <small>{{ $t('users.referrer') }}</small><br>
    <p v-if="whiteLabelUserSponsor">
      <b>{{ whiteLabelUserSponsor.name }}</b>  <br>
      <small>{{ whiteLabelUserSponsor.email }}
        <v-btn
          class="ml-2"
          x-small
          outlined
          text
          @click="$router.push(`/users?search=${whiteLabelUserSponsor.email}`)"
        >
          {{ $t('globals.findButton') }}
        </v-btn>
      </small>
    </p>
    <p v-else>
      <b>-</b>
    </p>
  </v-flex>
</template>

<script>

import WHITELABEL_USER_SPONSOR from "@/graphql/queries/WhiteLabelUserSponsor.gql";
import { mapGetters } from 'vuex'

export default {
  name: 'WhiteLabelUserSponsor',
  props: {
    userUuid:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      showFullAddress: false
    }
  },
  computed:{
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  apollo: {
    whiteLabelUserSponsor: {
      query: WHITELABEL_USER_SPONSOR,
      fetchPolicy: "network-only",
      variables() {
        return {
          user_uuid: this.userUuid
        }
      },
      skip() {
        return !this.getWhiteLabel || !this.getWhiteLabel.aff_plan
      }
    },
  }
}
</script>

